__turbopack_context__.v({
  "root": "style-module-scss-module__4p96ja__root",
  "wrapper": "style-module-scss-module__4p96ja__wrapper",
  "wrapper_hidden": "style-module-scss-module__4p96ja__wrapper_hidden",
});
